import { List, ListItemButton, ListItemText, Paper, Portal } from "@mui/material";

import type { ReactionResourceOption } from "@/components/global/components/tiptap/extensions/suggestion/suggestion-types";

interface SuggestionsMenuProps {
  resources: ReactionResourceOption[];
  highlightedIndex: number;
  /** Viewport (fixed) coordinates of the cursor for the dropdown anchor. */
  position: { top: number; left: number };
  onSelect: (resource: ReactionResourceOption) => void;
}

/**
 * Menu for displaying suggestions.
 * use preventDefault to keep editor focused while clicking around.
 */
export const SuggestionsMenu = ({ resources, highlightedIndex, position, onSelect }: SuggestionsMenuProps) => {
	return (
		<Portal>
			<Paper
				elevation={4}
				sx={{
					position: "fixed",
					top: position.top,
					left: position.left,
					zIndex: (theme) => theme.zIndex.modal + 2,
					minWidth: 260,
					maxHeight: 240,
					overflowY: "auto",
				}}
			>
				<List dense>
					{resources.length === 0 ? (
						<ListItemButton disabled>
							<ListItemText primary="No matches" />
						</ListItemButton>
					) : (
						resources.map((resource, index) => (
							<ListItemButton
								key={`${resource.resourceType}:${resource.value}`}
								selected={index === highlightedIndex}
								onMouseDown={(event) => {
									event.preventDefault();
									onSelect(resource);
								}}
							>
								<ListItemText
									primary={resource.label}
									secondary={resource.description}
								/>
							</ListItemButton>
						))
					)}
				</List>
			</Paper>
		</Portal>
	);
};
